import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { shipmentApi } from './api';
import { AddShipmentInput, EditShipmentInput, ShipmentQueryDto } from './types';

export const useEditShipments = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (inputs: EditShipmentInput[]) =>
      shipmentApi.editShipments(inputs),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['shipments'] });
      queryClient.invalidateQueries({ queryKey: ['allShipments'] });
    },
  });
};

export const useAddShipment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: AddShipmentInput) => shipmentApi.addShipment(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['shipments'] });
    },
  });
};

export const createShipmentOptions = (
  searchParams: URLSearchParams = new URLSearchParams(),
) => ({
  queryKey: ['shipments', searchParams.toString()],
  queryFn: () => shipmentApi.getShipments(searchParams),
});

export const useGetShipments = (query: ShipmentQueryDto = {}) => {
  const searchParams = new URLSearchParams();
  if (query.search) {
    searchParams.append('searchInput', query.search);
  }
  return useQuery({
    ...createShipmentOptions(searchParams),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};
